import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {
//URL:any="http://localhost:14080/";
URL:any="http://182.75.165.138:81/";


  constructor() { }

  ngOnInit() {
  }

  Report(Id:any)
  {
    debugger;
    window.open(this.URL+"?id=" + Id, "_blank")
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/reports.component.ts